import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllCreateYourOwnGenerals,
  getSingleCreateYourOwnGeneral,
  createCreateYourOwnGeneral,
  updateCreateYourOwnGeneral,
  deleteCreateYourOwnGeneral,
} from "@/api/new-api/staff-management/menu-manage/create-your-own-general";

// Thunks

export const fetchAllCreateYourOwnGenerals = createAsyncThunk(
  "createYourOwnGenerals/fetchAll",
  async (restaurant_id, { rejectWithValue }) => {
    const res = await getAllCreateYourOwnGenerals(restaurant_id);
    if (res.status === "success") return res.data.create_your_own_generals;
    return rejectWithValue(res.message);
  }
);

export const fetchSingleCreateYourOwnGeneral = createAsyncThunk(
  "createYourOwnGenerals/fetchOne",
  async (id, { rejectWithValue }) => {
    const res = await getSingleCreateYourOwnGeneral(id);
    if (res.status === "success") return res.data.create_your_own_general;
    return rejectWithValue(res.message);
  }
);

export const createNewCreateYourOwnGeneral = createAsyncThunk(
  "createYourOwnGenerals/create",
  async (data, { rejectWithValue }) => {
    const res = await createCreateYourOwnGeneral(data);
    if (res.status === "success") return res.data.create_your_own_general;
    return rejectWithValue(res.message);
  }
);

export const updateExistingCreateYourOwnGeneral = createAsyncThunk(
  "createYourOwnGenerals/update",
  async ({ id, data }, { rejectWithValue }) => {
    const res = await updateCreateYourOwnGeneral(id, data);
    if (res.status === "success") return res.data.create_your_own_general;
    return rejectWithValue(res.message);
  }
);

export const deleteCreateYourOwnGeneralById = createAsyncThunk(
  "createYourOwnGenerals/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteCreateYourOwnGeneral(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State
const initialState = {
  createYourOwnGenerals: [],
  singleCreateYourOwnGeneral: null,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  success: null,
  error: null,
  requestStatus: false,
};

// Slice
const createYourOwnGeneralSlice = createSlice({
  name: "createYourOwnGenerals",
  initialState,
  reducers: {
    clearCreateYourOwnGeneralMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchAllCreateYourOwnGenerals.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchAllCreateYourOwnGenerals.fulfilled, (state, action) => {
        state.getLoading = false;
        state.createYourOwnGenerals = action.payload || [];
        state.requestStatus = true;
      })
      .addCase(fetchAllCreateYourOwnGenerals.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Fetch Single
      .addCase(fetchSingleCreateYourOwnGeneral.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchSingleCreateYourOwnGeneral.fulfilled, (state, action) => {
        state.getLoading = false;
        state.singleCreateYourOwnGeneral = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchSingleCreateYourOwnGeneral.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Create
      .addCase(createNewCreateYourOwnGeneral.pending, (state) => {
        state.createLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(createNewCreateYourOwnGeneral.fulfilled, (state, action) => {
        state.createLoading = false;
        if (action.payload) {
          state.createYourOwnGenerals.push(action.payload);
        }
        state.success = "Choose Your Own created successfully!";
        state.requestStatus = true;
      })
      .addCase(createNewCreateYourOwnGeneral.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Update
      .addCase(updateExistingCreateYourOwnGeneral.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(updateExistingCreateYourOwnGeneral.fulfilled, (state, action) => {
        state.updateLoading = false;
        if (action.payload) {
          state.createYourOwnGenerals = state.createYourOwnGenerals.map((item) =>
            item.id === action.payload.id ? action.payload : item
          );
        }
        state.success = "Choose Your Own updated successfully!";
        state.requestStatus = true;
      })
      .addCase(updateExistingCreateYourOwnGeneral.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Delete
      .addCase(deleteCreateYourOwnGeneralById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(deleteCreateYourOwnGeneralById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.createYourOwnGenerals = state.createYourOwnGenerals.filter(
          (item) => item.id !== action.payload
        );
        state.success = "Choose Your Own deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteCreateYourOwnGeneralById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      });
  },
});

export const { clearCreateYourOwnGeneralMessages } =
  createYourOwnGeneralSlice.actions;
export default createYourOwnGeneralSlice.reducer;

